import React, { useCallback, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { isRtl } from "src/utils/helpers";
import {
  resetFilterData,
  setAssignedBuilding,
  setFilterDataField,
  setGridCurrentPage,
} from "src/redux/slices/assignBuildingSlice";
import useOnPageLeave from "src/hooks/useOnPageLeave";
import ToggleFilter from "src/components/ToggleFilter/ToggleFilter";
import useResize from "src/hooks/useResize";
import FilterActionButtons from "src/components/FilterActionButtons/FilterActionButtons";
import { getAssignedBuildingsLookup } from "src/redux/slices/lookupSlice";

const AssignedBuildingsFilter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration"]);

  const { isMobile } = useResize();
  const [isFilterShown, setIsFilterShown] = useState(!isMobile);

  const { propertyNumber, propertyId, contractNumber } = useSelector(
    (state: any) => state.assignBuilding.filterData
  );

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
  };
  const assignedBuildings = useSelector(
    (state: any) => state.lookup.assignedBuildings
  );
  const language = useSelector((state: any) => state.lookup.language);

  const handleFilter = () => {
    goToGridFirstPage();
  };

  const goToGridFirstPage = useCallback(() => {
    //dispatch(resetFilterData());
    dispatch(setGridCurrentPage(0));
  }, []);

  useEffect(() => {
    dispatch(getAssignedBuildingsLookup() as any);
  }, []);
  const handleFormFieldChange = (e: any) => {
    let name, value;
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = e.name;
      value = e.value;
    }
    dispatch(setFilterDataField({ field: name, value }));
  };

  const handleClearFilterForm = (): void => {
    dispatch(resetFilterData());
    goToGridFirstPage();
  };

  const onPageLeave = useCallback(() => {
    dispatch(resetFilterData());
    dispatch(setAssignedBuilding([]));
  }, []);
  useOnPageLeave(onPageLeave);

  const toggleFilter = () => {
    setIsFilterShown(!isFilterShown);
  };
  return (
    <>
      <ToggleFilter onClick={toggleFilter} />
      <div
        className={`pt-3 pb-2 px-2 maintenance-requests-filter assigned-buildings-filter ${
          !isMobile || isFilterShown ? "d-flex" : "d-none"
        } ${isMobile ? "my-3" : ""} `}
      >
        <p className="d-flex m-0 me-2 ms-2 mb-2 align-items-center fit-content filter-by-label">
          {t("filterBy")}
        </p>
        <form onSubmit={handleFormSubmit}>
          <div className="filter-row mb-2">
            <Dropdown
              filter
              resetFilterOnHide
              emptyFilterMessage={t("noResultsFound")}
              id="propertyId"
              options={assignedBuildings}
              placeholder={t("filterByBuilding")}
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              value={propertyId}
              optionValue={"propertyId"}
              optionLabel="buildingName"
              name="propertyId"
            />

            <InputText
              type="text"
              placeholder={t("propertyID")}
              onChange={handleFormFieldChange}
              value={propertyNumber}
              name="propertyNumber"
            />

            <InputText
              type="text"
              placeholder={t("contractNumber")}
              onChange={handleFormFieldChange}
              value={contractNumber}
              name="contractNumber"
            />

            <FilterActionButtons
              handleFilter={handleFilter}
              handleClear={handleClearFilterForm}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default AssignedBuildingsFilter;
